module.exports = __webpack_public_path__ + "img/isamilo_lodge_gallery_6.c8c31f13.jpeg";